import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn { from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)} }
  @keyframes modalIn { from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)} }
  @keyframes spin { to{transform:rotate(360deg)} }
  @keyframes shimmer { 0%{background-position:-600px 0}100%{background-position:600px 0} }
  *{box-sizing:border-box}
  .um-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .um-input{width:100%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;border-radius:10px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .um-input:focus{border-color:#63b3ed;background:#fff;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .um-input::placeholder{color:#a0aec0}
  .um-select{width:100%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;border-radius:10px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;cursor:pointer;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2363b3ed' stroke-width='2' fill='none'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 14px center;transition:border-color 0.2s,box-shadow 0.2s}
  .um-select:focus{border-color:#63b3ed;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .um-btn-primary{padding:11px 22px;background:linear-gradient(135deg,#63b3ed,#4299e1);border:none;border-radius:10px;color:#fff;font-size:14px;font-weight:600;font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;display:inline-flex;align-items:center;gap:8px}
  .um-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(66,153,225,0.35)}
  .um-btn-primary:disabled{opacity:0.6;cursor:not-allowed;transform:none}
  .um-btn-secondary{padding:11px 22px;background:#f0f4ff;border:1.5px solid #e2e8f5;border-radius:10px;color:#4a5568;font-size:14px;font-weight:600;font-family:'DM Sans',sans-serif;cursor:pointer;transition:background 0.15s,border-color 0.15s}
  .um-btn-secondary:hover{background:#e8eeff;border-color:#63b3ed;color:#3182ce}
  .um-row:hover td{background:#f0f7ff !important}
  .action-btn{width:32px;height:32px;border:none;border-radius:8px;cursor:pointer;font-size:14px;display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.15);box-shadow:0 4px 12px rgba(0,0,0,0.15)}
  .filter-btn{padding:8px 16px;border-radius:20px;border:1.5px solid #e2e8f5;background:#fff;color:#718096;font-size:13px;font-weight:600;font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.18s}
  .filter-btn.active{background:#63b3ed;border-color:#63b3ed;color:#fff;box-shadow:0 4px 12px rgba(99,179,237,0.3)}
  .filter-btn:hover:not(.active){border-color:#63b3ed;color:#3182ce}
  .search-input{padding:9px 16px 9px 40px;border:1.5px solid #e2e8f5;border-radius:20px;background:#fff;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;width:240px;transition:border-color 0.2s,box-shadow 0.2s,width 0.3s;color:#1a1d2e}
  .search-input:focus{border-color:#63b3ed;box-shadow:0 0 0 3px rgba(99,179,237,0.15);width:300px}
  .skeleton{background:linear-gradient(90deg,#f0f4ff 25%,#e8eeff 50%,#f0f4ff 75%);background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .um-label{font-size:12px;font-weight:600;color:#718096;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:3px 10px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(99,179,237,0.12);color:#63b3ed;border-left:3px solid #63b3ed;padding-left:13px}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#cbd5e0;border-radius:3px}
  .sec-div{display:flex;align-items:center;gap:12px;margin:22px 0 14px}
  .sec-div span{font-size:11px;font-weight:700;color:#a0aec0;text-transform:uppercase;letter-spacing:0.6px;white-space:nowrap}
  .sec-div::before,.sec-div::after{content:'';flex:1;height:1px;background:#e8eeff}
  .mod-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(155px,1fr));gap:8px}
  .mod-chip{display:flex;align-items:center;gap:8px;padding:9px 12px;border-radius:10px;cursor:pointer;border:1.5px solid #e2e8f5;background:#f8faff;transition:all 0.18s;user-select:none;font-size:13px;color:#4a5568}
  .mod-chip:hover{border-color:#63b3ed;background:#ebf8ff}
  .mod-chip.on{border-color:#63b3ed;background:#ebf8ff;color:#2b6cb0;font-weight:600}
  .chk{width:18px;height:18px;border-radius:5px;border:2px solid #cbd5e0;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all 0.18s;background:#fff}
  .mod-chip.on .chk{background:#63b3ed;border-color:#63b3ed}
  .mod-chip.on .chk::after{content:'✓';color:#fff;font-size:11px;font-weight:800}
  .admin-badge{display:inline-flex;align-items:center;gap:8px;padding:10px 16px;border-radius:10px;background:linear-gradient(135deg,#ebf8ff,#bee3f8);border:1.5px solid #90cdf4;color:#2b6cb0;font-size:13px;font-weight:600}
`;

// const NAV = [
//   {icon:'⬡',label:'Dashboard',      path:'/dashboard'},
//   {icon:'👥',label:'User Management',path:'/user-management'},
//   // { icon: '🌤️', label: 'Season Name',      path: '/season-name'    },
//   // { icon: '📅',  label: 'Season Duration',  path: '/season-duration'   },
//   {
//     icon: '🌤️',
//     label: 'Season Management',
//     children: [
//       { icon: '🌤️', label: 'Season Name', path: '/season-name' },
//       { icon: '📅', label: 'Season Duration', path: '/season-duration' }
//     ]
//   },
//   {icon:'⏱️', label:'Rent Durations',  path:'/rent-durations'},
//   {icon:'📋',label:'Bookings',       path:'/bookings'},
//   {icon:'🚘',label:'Vehicles',       path:'/vehicles'},
//   {icon:'👤',label:'Customers',      path:'/customers'},
//   {icon:'💳',label:'Payments',       path:'/payments'},
// ];

const EMPTY = {user_name:'',user_loginId:'',user_emailId:'',user_telno:'',user_address:'',user_type:'2',user_password:'',confirmPassword:'',mod_ids:[]};

export default function UserManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  const [authUser,     setAuthUser]     = useState(null);
  const [sideOpen,     setSideOpen]     = useState(true);
  const [users,        setUsers]        = useState([]);
  const [allMods,      setAllMods]      = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [search,       setSearch]       = useState('');
  const [typeF,        setTypeF]        = useState('all');
  const [statusF,      setStatusF]      = useState('all');
  const [modal,        setModal]        = useState(null);
  const [selUser,      setSelUser]      = useState(null);
  const [form,         setForm]         = useState(EMPTY);
  const [saving,       setSaving]       = useState(false);
  const [toast,        setToast]        = useState(null);
  const [openMenu,     setOpenMenu]     = useState(null);
  const [page,         setPage]         = useState(1);
  const [viewMods,     setViewMods]     = useState([]);
  const PER = 10;

  // useEffect(()=>{
  //   if(!localStorage.getItem('token')){navigate('/login');return;}
  //   setAuthUser(JSON.parse(localStorage.getItem('user')||'{}'));
  //   fetchUsers(); fetchMods();
  // },[]);

  useEffect(()=>{
    if(!localStorage.getItem('token')){
      navigate('/login');
      return;
    }
    setAuthUser(JSON.parse(localStorage.getItem('user')||'{}'));
    fetchUsers();
    fetchMods();
  },[navigate]);

  
  const fetchUsers = async()=>{
    setLoading(true);
    try{const r=await API.get('/users');setUsers(r.data);}
    catch(e){toast2('Failed to load users','error');}
    setLoading(false);
  };

  const fetchMods = async()=>{
    try{const r=await API.get('/users/modules');setAllMods(r.data);}
    catch(e){console.error(e);}
  };

  const fetchUserMods = async(uid)=>{
    try{const r=await API.get(`/users/${uid}/modules`);return r.data.map(Number);}
    catch(e){return[];}
  };

  const toast2=(msg,type='success')=>{
    setToast({msg,type});
    setTimeout(()=>setToast(null),3500);
  };

  const openAdd =()=>{setForm({...EMPTY});setSelUser(null);setModal('add');};
  const openEdit=async(u)=>{
    setSelUser(u);
    const mods=await fetchUserMods(u.user_id);
    setForm({user_name:u.user_name,user_loginId:u.user_loginId,user_emailId:u.user_emailId,
      user_telno:u.user_telno||'',user_address:u.user_address||'',user_type:String(u.user_type),
      user_password:'',confirmPassword:'',mod_ids:mods});
    setModal('edit');
  };
  const openView=async(u)=>{
    setSelUser(u);
    const mods=await fetchUserMods(u.user_id);
    setViewMods(mods);
    setModal('view');
  };
  const openDel=(u)=>{setSelUser(u);setModal('delete');};

  const toggleMod=(id)=>{
    const mid=Number(id);
    setForm(p=>({...p,mod_ids:p.mod_ids.includes(mid)?p.mod_ids.filter(m=>m!==mid):[...p.mod_ids,mid]}));
  };

  const handleSave=async()=>{
    if(!form.user_name||!form.user_loginId||!form.user_emailId){toast2('Name, Login ID and Email required','error');return;}
    if(modal==='add'&&!form.user_password){toast2('Password required','error');return;}
    if(form.user_password&&form.user_password!==form.confirmPassword){toast2('Passwords do not match','error');return;}
    setSaving(true);
    try{
      if(modal==='add'){await API.post('/users',form);toast2('User added ✓');}
      else{await API.put(`/users/${selUser.user_id}`,form);toast2('User updated ✓');}
      setModal(null);fetchUsers();
    }catch(e){toast2(e.response?.data?.message||'Operation failed','error');}
    setSaving(false);
  };

  const handleDelete=async()=>{
    setSaving(true);
    try{
      await API.delete(`/users/${selUser.user_id}`);
      toast2('User deleted ✓');setModal(null);fetchUsers();
    }catch(e){toast2(e.response?.data?.message||'Delete failed','error');}
    setSaving(false);
  };

  const handleToggle=async(u)=>{
    try{
      const ns=u.user_status===1?2:1;
      await API.patch(`/users/${u.user_id}/status`,{status:ns});
      toast2(`User ${ns===1?'activated':'deactivated'} ✓`);fetchUsers();
    }catch(e){toast2(e.response?.data?.message||'Failed','error');}
  };

  const filtered=users.filter(u=>{
    const q=search.toLowerCase();
    const ms=!search||u.user_name?.toLowerCase().includes(q)||u.user_emailId?.toLowerCase().includes(q)||u.user_loginId?.toLowerCase().includes(q);
    const mt=typeF==='all'||String(u.user_type)===typeF;
    const mst=statusF==='all'||String(u.user_status)===statusF;
    return ms&&mt&&mst;
  });
  const totalPages=Math.ceil(filtered.length/PER);
  const paged=filtered.slice((page-1)*PER,page*PER);
  const logout=()=>{localStorage.clear();navigate('/login');};
  const fld=(k)=>(e)=>setForm(p=>({...p,[k]:e.target.value}));
  const isAdmin=form.user_type==='1';

  /* Module panel component */
  const ModPanel=()=>(
    <div>
      <div className="sec-div"><span>Module Permissions</span></div>
      {isAdmin?(
        <div className="admin-badge">
          <span style={{fontSize:20}}>🛡️</span>
          Admin users automatically receive full access to all {allMods.length} modules
        </div>
      ):(
        <>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
            <span style={{fontSize:12,color:'#a0aec0'}}>
              {form.mod_ids.length} of {allMods.length} modules selected
            </span>
            <div style={{display:'flex',gap:6}}>
              <button type="button" onClick={()=>setForm(p=>({...p,mod_ids:allMods.map(m=>Number(m.mod_id))}))}
                style={{padding:'4px 12px',border:'1.5px solid #63b3ed',borderRadius:20,background:'#ebf8ff',
                  color:'#2b6cb0',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
                Select All
              </button>
              <button type="button" onClick={()=>setForm(p=>({...p,mod_ids:[]}))}
                style={{padding:'4px 12px',border:'1.5px solid #e2e8f5',borderRadius:20,background:'#f8faff',
                  color:'#718096',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
                Clear All
              </button>
            </div>
          </div>
          {allMods.length===0?(
            <div style={{textAlign:'center',padding:20,color:'#a0aec0',fontSize:13,
              background:'#f8faff',borderRadius:10,border:'1.5px dashed #e2e8f5'}}>
              No modules available in database
            </div>
          ):(
            <div className="mod-grid">
              {allMods.map(mod=>{
                const checked=form.mod_ids.includes(Number(mod.mod_id));
                return(
                  <div key={mod.mod_id} className={`mod-chip${checked?' on':''}`}
                    onClick={()=>toggleMod(mod.mod_id)}>
                    <div className="chk"/>
                    <span>{mod.mod_name||mod.mod_title||`Module ${mod.mod_id}`}</span>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );

  return(
    <Layout activePage="User Management">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="um-root">

        {/* Sidebar */}
        {/* <aside style={{...S.sidebar,width:sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen&&<span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
  {NAV.map(n => (
    <div key={n.label}>

      {/* Parent */}
      {/* <div
        className={`nav-item ${location.pathname === n.path ? 'active' : ''}`}
        onClick={() => {
          if (n.children) {
            setOpenMenu(openMenu === n.label ? null : n.label);
          } else {
            navigate(n.path);
          }
        }}
      >
        <span style={{fontSize:16}}>{n.icon}</span>
        {sideOpen && (
          <>
            <span>{n.label}</span>
            {n.children && (
              <span style={{marginLeft:'auto'}}>
                {openMenu === n.label ? '▲' : '▼'}
              </span>
            )}
          </>
        )}
      </div> */}

      {/* Children */}
      {/* {n.children && openMenu === n.label && (
        <div style={{marginLeft: sideOpen ? 25 : 0}}>
          {n.children.map(child => (
            <div
              key={child.label}
              className={`nav-item ${location.pathname === child.path ? 'active' : ''}`}
              style={{fontSize:13, paddingTop:8, paddingBottom:8}}
              onClick={() => navigate(child.path)}
            >
              <span>{child.icon}</span>
              {sideOpen && <span>{child.label}</span>}
            </div>
          ))}
        </div>
      )}

    </div>
  ))}
</nav>
          <div style={S.sideBottom}>
            {sideOpen&&(
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* Main */}
        <main>
          <div style={S.header}>
            <div>
              <h1 style={S.pageTitle}>User Management</h1>
              <p style={S.pageSub}>{users.length} total · {users.filter(u=>u.user_status===1).length} active</p>
            </div>
            <button className="um-btn-primary" onClick={openAdd}>
              <span style={{fontSize:18}}>＋</span> Add New User
            </button>
          </div>

          {/* Stats */}
          <div style={S.statsRow}>
            {[
              {label:'Total Users',  value:users.length,                             color:'#6C63FF',bg:'#f3f2ff',icon:'👥'},
              {label:'Admin Users',  value:users.filter(u=>u.user_type===1).length,  color:'#63b3ed',bg:'#ebf8ff',icon:'🛡️'},
              {label:'General',      value:users.filter(u=>u.user_type===2).length,  color:'#48bb78',bg:'#f0fff4',icon:'👤'},
              {label:'Inactive',     value:users.filter(u=>u.user_status===2).length,color:'#fc8181',bg:'#fff5f5',icon:'⛔'},
            ].map(s=>(
              <div key={s.label} style={{...S.statCard,background:s.bg,borderLeft:`4px solid ${s.color}`}}>
                <div style={{fontSize:24,marginBottom:6}}>{s.icon}</div>
                <div style={{fontSize:26,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                <div style={{fontSize:11,color:'#718096',fontWeight:600,marginTop:4,textTransform:'uppercase',letterSpacing:'0.4px'}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Filters */}
          <div style={S.filterBar}>
            <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
              <span style={{fontSize:13,color:'#a0aec0',fontWeight:600}}>Type:</span>
              {[['all','All'],['1','Admin'],['2','General']].map(([v,l])=>(
                <button key={v} className={`filter-btn${typeF===v?' active':''}`}
                  onClick={()=>{setTypeF(v);setPage(1);}}>{l}</button>
              ))}
              <span style={{fontSize:13,color:'#a0aec0',fontWeight:600,marginLeft:8}}>Status:</span>
              {[['all','All'],['1','Active'],['2','Inactive']].map(([v,l])=>(
                <button key={v} className={`filter-btn${statusF===v?' active':''}`}
                  onClick={()=>{setStatusF(v);setPage(1);}}>{l}</button>
              ))}
            </div>
            <div style={{position:'relative'}}>
              <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
              <input className="search-input" placeholder="Search users…"
                value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
            </div>
          </div>

          {/* Table */}
          <div style={S.tableWrap}>
            <table style={S.table}>
              <thead>
                <tr style={{background:'linear-gradient(135deg,#f8faff,#f0f4ff)'}}>
                  {['#','Name','Login ID','Email','Type','Modules','Status','Actions'].map(h=>(
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading
                  ?Array.from({length:6}).map((_,i)=>(
                    <tr key={i}>{Array.from({length:8}).map((_,j)=>(
                      <td key={j} style={S.td}><div className="skeleton" style={{height:14,width:'70%'}}/></td>
                    ))}</tr>
                  ))
                  :paged.length===0
                  ?<tr><td colSpan={8} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                    <div style={{fontSize:32,marginBottom:8}}>🔍</div>
                    <div style={{fontSize:14,fontWeight:600}}>No users found</div>
                  </td></tr>
                  :paged.map((u,i)=>(
                    <tr key={u.user_id} className="um-row" style={{borderBottom:'1px solid #f0f4ff'}}>
                      <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>{(page-1)*PER+i+1}</td>
                      <td style={S.td}>
                        <div style={{display:'flex',alignItems:'center',gap:10}}>
                          <div style={{...S.miniAvatar,background:u.user_type===1?'linear-gradient(135deg,#63b3ed,#4299e1)':'linear-gradient(135deg,#9f7aea,#805ad5)'}}>
                            {u.user_name?.[0]?.toUpperCase()}
                          </div>
                          <div>
                            <div style={{fontWeight:600,fontSize:14,color:'#1a1d2e'}}>{u.user_name}</div>
                            <div style={{fontSize:11,color:'#a0aec0'}}>{u.user_telno||'—'}</div>
                          </div>
                        </div>
                      </td>
                      <td style={S.td}>
                        <span style={{fontFamily:'monospace',fontSize:13,color:'#4a5568',background:'#f0f4ff',padding:'3px 8px',borderRadius:6}}>
                          {u.user_loginId}
                        </span>
                      </td>
                      <td style={{...S.td,color:'#4a5568',fontSize:13}}>{u.user_emailId}</td>
                      <td style={S.td}>
                        <span className="badge" style={u.user_type===1?{background:'#ebf8ff',color:'#2b6cb0'}:{background:'#faf5ff',color:'#6b46c1'}}>
                          {u.user_type===1?'🛡️ Admin':'👤 General'}
                        </span>
                      </td>
                      <td style={S.td}>
                        {u.user_type===1
                          ?<span className="badge" style={{background:'#f0fff4',color:'#276749'}}>All Access</span>
                          :<span className="badge" style={{background:'#fefcbf',color:'#744210'}}>Custom</span>
                        }
                      </td>
                      <td style={S.td}>
                        <div style={{display:'flex',alignItems:'center',gap:8}}>
                          <div style={{position:'relative',width:44,height:24}}>
                            <div onClick={()=>handleToggle(u)} style={{width:44,height:24,borderRadius:12,cursor:'pointer',
                              background:u.user_status===1?'#48bb78':'#e2e8f0',transition:'background 0.25s',position:'relative'}}>
                              <div style={{position:'absolute',width:18,height:18,borderRadius:'50%',background:'#fff',top:3,
                                left:u.user_status===1?23:3,transition:'left 0.25s',boxShadow:'0 1px 4px rgba(0,0,0,0.2)'}}/>
                            </div>
                          </div>
                          <span style={{fontSize:12,fontWeight:600,color:u.user_status===1?'#48bb78':'#a0aec0'}}>
                            {u.user_status===1?'Active':'Inactive'}
                          </span>
                        </div>
                      </td>
                      <td style={S.td}>
                        <div style={{display:'flex',gap:6}}>
                          <button className="action-btn" style={{background:'#ebf8ff',color:'#2b6cb0'}} title="View" onClick={()=>openView(u)}>👁</button>
                          <button className="action-btn" style={{background:'#fefcbf',color:'#744210'}} title="Edit" onClick={()=>openEdit(u)}>✏️</button>
                          <button className="action-btn" style={{background:'#fff5f5',color:'#c53030'}} title="Delete" onClick={()=>openDel(u)}>🗑</button>
                        </div>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>

          {totalPages>1&&(
            <div style={S.pagination}>
              <span style={{fontSize:13,color:'#718096'}}>
                Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
              </span>
              <div style={{display:'flex',gap:6}}>
                <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                  <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}} onClick={()=>setPage(p)}>{p}</button>
                ))}
                <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
              </div>
            </div>
          )}
        </main>

        {/* Add/Edit Modal */}
        {(modal==='add'||modal==='edit')&&(
          <div style={S.overlay} onClick={()=>setModal(null)}>
            <div style={S.modal} onClick={e=>e.stopPropagation()}>
              <div style={{...S.modalHead,paddingBottom:16}}>
                <div>
                  <h2 style={S.modalTitle}>{modal==='add'?'➕ Add New User':'✏️ Edit User'}</h2>
                  <p style={S.modalSub}>{modal==='add'?'Fill in details and set module permissions':`Editing: ${selUser?.user_name}`}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setModal(null)}>✕</button>
              </div>

              <div className="modal-scroll">
                <div className="sec-div"><span>Basic Information</span></div>
                <div style={S.formGrid}>
                  <div>
                    <label className="um-label">Full Name *</label>
                    <input className="um-input" placeholder="e.g. John Smith" value={form.user_name} onChange={fld('user_name')}/>
                  </div>
                  <div>
                    <label className="um-label">Login ID *</label>
                    <input className="um-input" placeholder="e.g. jsmith" value={form.user_loginId} onChange={fld('user_loginId')}/>
                  </div>
                  <div style={{gridColumn:'1/-1'}}>
                    <label className="um-label">Email Address *</label>
                    <input className="um-input" type="email" placeholder="john@example.com" value={form.user_emailId} onChange={fld('user_emailId')}/>
                  </div>
                  <div>
                    <label className="um-label">Phone Number</label>
                    <input className="um-input" type="tel" placeholder="+91 98765 43210" value={form.user_telno} onChange={fld('user_telno')}/>
                  </div>
                  <div>
                    <label className="um-label">User Type *</label>
                    <select className="um-select" value={form.user_type}
                      onChange={e=>setForm(p=>({...p,user_type:e.target.value,mod_ids:e.target.value==='1'?[]:p.mod_ids}))}>
                      <option value="1">🛡️ Admin User</option>
                      <option value="2">👤 General User</option>
                    </select>
                  </div>
                  <div style={{gridColumn:'1/-1'}}>
                    <label className="um-label">Address</label>
                    <input className="um-input" placeholder="Street, City, Country" value={form.user_address} onChange={fld('user_address')}/>
                  </div>
                  <div>
                    <label className="um-label">{modal==='edit'?'New Password (blank = keep)':'Password *'}</label>
                    <input className="um-input" type="password" placeholder="Min 6 characters" value={form.user_password} onChange={fld('user_password')}/>
                  </div>
                  <div>
                    <label className="um-label">Confirm Password</label>
                    <input className="um-input" type="password" placeholder="Re-enter password" value={form.confirmPassword} onChange={fld('confirmPassword')}/>
                  </div>
                </div>
                <ModPanel/>
              </div>

              <div style={S.modalFoot}>
                <button className="um-btn-secondary" onClick={()=>setModal(null)}>Cancel</button>
                <button className="um-btn-primary" onClick={handleSave} disabled={saving}>
                  {saving?<span style={S.spinner}/>:modal==='add'?'Create User':'Save Changes'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* View Modal */}
        {modal==='view'&&selUser&&(
          <div style={S.overlay} onClick={()=>setModal(null)}>
            <div style={{...S.modal,maxWidth:520}} onClick={e=>e.stopPropagation()}>
              <div style={{...S.modalHead,paddingBottom:16}}>
                <h2 style={S.modalTitle}>👁 User Profile</h2>
                <button style={S.xBtn} onClick={()=>setModal(null)}>✕</button>
              </div>
              <div className="modal-scroll">
                <div style={{textAlign:'center',marginBottom:20}}>
                  <div style={{...S.bigAvatar,margin:'0 auto 12px',
                    background:selUser.user_type===1?'linear-gradient(135deg,#63b3ed,#4299e1)':'linear-gradient(135deg,#9f7aea,#805ad5)'}}>
                    {selUser.user_name?.[0]?.toUpperCase()}
                  </div>
                  <h3 style={{fontSize:20,fontWeight:700,color:'#1a1d2e',marginBottom:4}}>{selUser.user_name}</h3>
                  <span className="badge" style={selUser.user_type===1?{background:'#ebf8ff',color:'#2b6cb0'}:{background:'#faf5ff',color:'#6b46c1'}}>
                    {selUser.user_type===1?'🛡️ Admin':'👤 General User'}
                  </span>
                </div>
                {[
                  {label:'Login ID',value:selUser.user_loginId,icon:'🔑'},
                  {label:'Email',value:selUser.user_emailId,icon:'✉️'},
                  {label:'Phone',value:selUser.user_telno||'—',icon:'📞'},
                  {label:'Address',value:selUser.user_address||'—',icon:'📍'},
                  {label:'Status',value:selUser.user_status===1?'Active':'Inactive',icon:'🟢'},
                  {label:'Created',value:selUser.user_createddate?.split('T')[0]||selUser.user_createddate||'—',icon:'📅'},
                ].map(r=>(
                  <div key={r.label} style={{display:'flex',alignItems:'flex-start',gap:14,padding:'10px 0',borderBottom:'1px solid #f8faff'}}>
                    <div style={{width:34,height:34,background:'#f0f4ff',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:15,flexShrink:0}}>{r.icon}</div>
                    <div>
                      <div style={{fontSize:11,color:'#a0aec0',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'}}>{r.label}</div>
                      <div style={{fontSize:14,color:'#2d3748',fontWeight:500,marginTop:2}}>{r.value}</div>
                    </div>
                  </div>
                ))}

                <div className="sec-div"><span>Module Access</span></div>
                {selUser.user_type===1?(
                  <div className="admin-badge"><span style={{fontSize:18}}>🛡️</span>Full access to all modules</div>
                ):(
                  <div className="mod-grid">
                    {allMods.length===0&&<p style={{color:'#a0aec0',fontSize:13}}>No modules found</p>}
                    {allMods.map(mod=>{
                      const assigned=viewMods.includes(Number(mod.mod_id));
                      return(
                        <div key={mod.mod_id} style={{display:'flex',alignItems:'center',gap:8,padding:'8px 12px',borderRadius:10,fontSize:13,
                          background:assigned?'#f0fff4':'#f8faff',border:`1.5px solid ${assigned?'#9ae6b4':'#e2e8f5'}`,
                          color:assigned?'#276749':'#a0aec0'}}>
                          <span style={{fontSize:14}}>{assigned?'✅':'⭕'}</span>
                          {mod.mod_name||mod.mod_title||`Module ${mod.mod_id}`}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div style={S.modalFoot}>
                <button className="um-btn-secondary" onClick={()=>setModal(null)}>Close</button>
                <button className="um-btn-primary" onClick={()=>{setModal(null);setTimeout(()=>openEdit(selUser),100);}}>Edit User</button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Modal */}
        {modal==='delete'&&selUser&&(
          <div style={S.overlay} onClick={()=>setModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete User?</h2>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  Are you sure you want to delete <strong style={{color:'#1a1d2e'}}>{selUser.user_name}</strong>?<br/>This action cannot be undone.
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="um-btn-secondary" onClick={()=>setModal(null)}>Cancel</button>
                  <button disabled={saving} onClick={handleDelete} style={{padding:'11px 22px',
                    background:'linear-gradient(135deg,#fc8181,#e53e3e)',border:'none',borderRadius:10,
                    color:'#fff',fontWeight:600,fontSize:14,fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {saving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {toast&&(
          <div style={{...S.toast,background:toast.type==='error'?'#fff5f5':'#f0fff4',
            borderColor:toast.type==='error'?'#fc8181':'#68d391',color:toast.type==='error'?'#c53030':'#276749'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

const S={
  root:{display:'flex',minHeight:'100vh',background:'#f4f6fb'},
  // sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
  // sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
  // logoWrap:{display:'flex',alignItems:'center',gap:10},
  // logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#63b3ed,#4299e1)',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
  // logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
  // collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
  // sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
  // userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
  // avatar:{width:36,height:36,background:'linear-gradient(135deg,#63b3ed,#4299e1)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
  // uname:{fontSize:13,fontWeight:700,color:'#fff'},
  // urole:{fontSize:11,color:'#777'},
  logoutBtn:{width:'100%',background:'rgba(255,100,100,0.12)',border:'1px solid rgba(255,100,100,0.2)',color:'#ff6b6b',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},
  main:{flex:1,padding:'28px',transition:'margin-left 0.25s',minWidth:0},
  header:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  statsRow:{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16,marginBottom:24},
  statCard:{borderRadius:14,padding:'18px 20px',boxShadow:'0 2px 12px rgba(0,0,0,0.05)'},
  filterBar:{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12,marginBottom:16,background:'#fff',borderRadius:14,padding:'14px 18px',boxShadow:'0 2px 12px rgba(0,0,0,0.05)'},
  tableWrap:{background:'#fff',borderRadius:16,overflow:'hidden',boxShadow:'0 2px 16px rgba(0,0,0,0.06)',marginBottom:16},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'14px 16px',fontSize:11,fontWeight:700,color:'#718096',textAlign:'left',textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #e8eeff'},
  td:{padding:'12px 16px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},
  miniAvatar:{width:36,height:36,borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:14,flexShrink:0},
  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',background:'#fff',borderRadius:12,padding:'12px 18px',boxShadow:'0 2px 8px rgba(0,0,0,0.04)'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #e2e8f5',borderRadius:8,background:'#fff',color:'#718096',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#63b3ed',borderColor:'#63b3ed',color:'#fff'},
  overlay:{position:'fixed',inset:0,background:'rgba(10,15,40,0.6)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:660,maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 32px 80px rgba(0,0,0,0.25)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',padding:'16px 28px',borderTop:'1px solid #f0f4ff',flexShrink:0},
  xBtn:{background:'rgba(255,107,107,0.1)',border:'none',color:'#fc8181',borderRadius:'50%',width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,display:'flex',alignItems:'center',justifyContent:'center'},
  formGrid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16},
  bigAvatar:{width:72,height:72,borderRadius:20,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:800,fontSize:28},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 20px',borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.1)',animation:'fadeSlideIn 0.3s ease'},
};